module.exports = __webpack_public_path__ + "static/media/IlotE_synthese_1.40391435.webp";